import { ValueOf } from "type-fest";

import { Group, License } from "@dashboard/devices/types";
import { getDevicePolicyStatus, getLicenseActivationStatusKey, policyStatusKey } from "@dashboard/devices/utils/license";

type FilterStateProperties = {
    licenseStatus: string[];
    onlineStatus: string[];
    policyStatus: string[];
    systemVersion: string[];
    codename: string[];
    groupName: string[];
};

function testCondition({ values = [], target = "" }: { values: ValueOf<FilterStateProperties>; target: string | null }) {
    let result = null;
    if (values && values.length) {
        result = values.some((filterValue) => filterValue.toLowerCase() === target?.toLowerCase());
    }

    return result;
}

interface FilterLicensesByProperties {
    licenses: License[];
    filters: FilterStateProperties;
    groups: Group[];
}

export function filterLicensesByProperties({ licenses, filters, groups }: FilterLicensesByProperties): License[] {
    const filteredData = licenses.filter((license) => {
        let filterResults = [];

        if (filters["licenseStatus"].length) {
            filterResults.push(
                testCondition({
                    values: filters["licenseStatus"],
                    target: getLicenseActivationStatusKey(license),
                }),
            );
        }

        const policyStatus = policyStatusKey(getDevicePolicyStatus(license.device, groups));
        const version = license.device?.lastState?.version.emteriaVersion || "";
        const groupId = String(license.groupId);

        if (filters["onlineStatus"].length) {
            const _deviceStatus = testCondition({
                values: filters["onlineStatus"],
                target: license?.device?.isOnline ? "Online" : "Offline",
            });
            filterResults.push(_deviceStatus);
        }

        if (filters["policyStatus"].length) {
            const _policyStatus = testCondition({
                values: filters["policyStatus"],
                target: policyStatus,
            });
            filterResults.push(_policyStatus);
        }
        if (filters["policyStatus"].length && !policyStatus) {
            filterResults.push(false);
        }
        if (filters["systemVersion"].length) {
            const _version = testCondition({
                values: filters["systemVersion"],
                target: version,
            });
            filterResults.push(_version);
        }
        if (filters["groupName"].length) {
            const _group = testCondition({
                values: filters["groupName"],
                target: groupId,
            });
            filterResults.push(_group);
        }

        filterResults = filterResults.filter((value) => value !== null);

        return filterResults.length > 0 ? filterResults.every((item) => item) : true;
    });

    return filteredData;
}
